import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import React, { Suspense } from 'react'

const CategoryCard = React.lazy(() => import('./CategoryCard'));

const CategoryWrapper = ({ items }) => {
    return (
        <Box>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    {items.map((item, index) => (
                        <Grid item xs={3} sm={3} md={3} key={index}>
                            <Suspense fallback={<div>Loading...</div>}>
                                <CategoryCard item={item} />
                            </Suspense>
                        </Grid>
                    ))}
                </Grid>
            </Box>            
        </Box>
    )
}

export default CategoryWrapper